<template>
  <h1 class="system_content_title">培训视频管理</h1>
  <div class="system_content_panels">
    <div class="systemPanel" style="position: relative; padding-bottom: 40px">
    

      <el-table
        :data="state.tableData"
        stripe
        v-loading="state.loading"
        style="min-height: 70vh"
        table-layout="fixed"
      >

        <el-table-column type="index" label="序号" width="80">
        </el-table-column>
        <el-table-column prop="title" label="名称" sortable>
        </el-table-column>
        <el-table-column
          prop="environmentunitName"
          label="发布单位"
          sortable
        >
        </el-table-column>
       
      
       
   
        <el-table-column label="文件" >
          <template #default="scope">
        <a :href="BASE_URL+scope.row.fileUrl"  target="_blank">{{getFileName(scope.row.fileUrl)}}</a>
           
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="state.pageInfo.pageIndex"
        :page-sizes="[20, 50, 100, 200, 500, 1000]"
        :page-size="state.pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="state.pageInfo.totalRowCount"
        v-if="state.pageInfo.totalRowCount"
        class="pageinfo"
      >
      </el-pagination>
    </div>
 
  </div>
</template>

<script>
import { onMounted, reactive } from "vue-demi";
import api from "../../http/apis";
import { ElMessageBox, ElMessage, ElNotification } from "element-plus";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { DArrowLeft } from "@element-plus/icons-vue";
import CONSTS from "../../store/consts";
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const BASE_URL = CONSTS.BASE_URL.slice(0, -1) ;
   
    const state = reactive({
      tableData: [],
     
      loading: false,
      searchInput: "",
      pageInfo: {},
   
    });

    const getTableData = async () => {
      state.loading = true;
      const { data } = await api.miscApi.getAllVideos({
        page: state.pageInfo.pageIndex || 1,
        rows: state.pageInfo.pageSize || 20,
        sort: "",
        value: state.searchInput,
       
      });
      if (data.isSuccessful) {
        state.loading = false;
        state.tableData = data.resultObj.data;
        state.pageInfo = data.resultObj.pagerInfo;
      } else if (data.resultMsg) {
        ElMessage({
          message: data.resultMsg,
          type: "error",
        });
      } else {
        ElMessage({});
      }
    };

  getTableData()

   
    const handleChange = (index) => {
      // 下拉选择框
      state.audID = state.audItemList[index].id;
      state.audName = state.audItemList[index].name;
    };
    const showAdd = () => {
      state.addVisible = true;
    };
 

   
    const getFileName = (val) => {
      if (val != null) {
        if (val || val != "") {
          console.info("fileurl", val);
          const fileUrl = val.split("/");
          const fileName = fileUrl.pop();
          return fileName;
        } else {
          const str = "无";
          return str;
        }
      }
    };

  
    
    

    const showDetail = async (id) => {
      // const {data}=await api.reviewTaskApi.getReviewFormByID(id)
      // console.info("get review form",data)

      const path = `/system/audition/auditionDetail?unitAID=${id}`;
      const routerData = router.resolve(path);
      window.open(routerData.href, "_blank");
      return;
    };
  const replaceChinese=(str) =>{
      str = str.replace(/[\u4e00-\u9fa5]/g, "");
      return str;
    }
    return {
      state,
      getTableData,
     BASE_URL,
      showDetail,
      showAdd,
      handleChange,
    
      getFileName,
     
      replaceChinese
    };
  },
  methods: {
    handleSizeChange(val) {
      this.state.pageInfo.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.state.pageInfo.pageIndex = val;
      this.getTableData();
    },
    getBack() {
      window.history.go(-1);
    },
  },
};
</script>

<style scoped lang='scss'>
@use "../../assets/scss/table.scss" as *;

.el-input__inner {
  width: 100%;
}
</style>
